<span class="badge badge-primary" *ngFor="let x of tags">{{x.titulo}}</span>
